import React from 'react';
import clsx from 'clsx';
import { CheckIcon } from '@heroicons/react/24/outline';
import type { ConfigRegrasCliente, Movimentacao } from '../../../models';
import GerarTermoButton from './GerarTermoButton';
import TermoAssinadoSection from './TermoAssinadoSection';

interface TermoPassosProps {
  solicitacaoId: string;
  movimentacao: Movimentacao;
  colaboradorId: string | null;
  clienteNome: string | null;
  regraCliente: ConfigRegrasCliente | undefined;
  onToggleEnviado: () => void;
}

function Numero({ n, feito }: { n: number; feito: boolean }) {
  return (
    <span
      className={clsx(
        'flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-semibold',
        feito ? 'bg-primary-500 text-white' : 'bg-gray-200 text-gray-700'
      )}
      aria-hidden="true"
    >
      {feito ? <CheckIcon className="h-4 w-4" /> : n}
    </span>
  );
}

/** O Termo em 3 passos, na ordem em que acontecem: gerar → enviar pelo D4Sign → anexar o
 * assinado (obrigatório pra concluir). Na gaveta da Movimentação. */
export default function TermoPassos({
  solicitacaoId,
  movimentacao,
  colaboradorId,
  clienteNome,
  regraCliente,
  onToggleEnviado,
}: TermoPassosProps) {
  const gerado = Boolean(movimentacao.termoUrl);
  const enviado = movimentacao.etapas.termo === 'concluido';
  return (
    <ol className="space-y-5">
      <li className="flex gap-3">
        <Numero n={1} feito={gerado} />
        <div className="min-w-0 flex-1 space-y-2">
          <p className="font-semibold text-gray-900">Gerar o termo</p>
          <p className="text-xs text-gray-500">Leva a data da logística e as fotos de cada equipamento.</p>
          <GerarTermoButton
            solicitacaoId={solicitacaoId}
            movimentacao={movimentacao}
            colaboradorId={colaboradorId}
            clienteNome={clienteNome}
            regraCliente={regraCliente}
          />
        </div>
      </li>
      <li className="flex gap-3">
        <Numero n={2} feito={enviado} />
        <div className="min-w-0 flex-1 space-y-2">
          <p className="font-semibold text-gray-900">Enviar pelo D4Sign</p>
          <label className="flex items-center gap-2 text-sm text-gray-700">
            <input
              type="checkbox"
              className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
              checked={enviado}
              onChange={onToggleEnviado}
            />
            Termo enviado pra assinatura
          </label>
        </div>
      </li>
      <li className="flex gap-3">
        <Numero n={3} feito={Boolean(movimentacao.termoAssinado?.url)} />
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-gray-900">Anexar o assinado</p>
          <TermoAssinadoSection solicitacaoId={solicitacaoId} movimentacao={movimentacao} colaboradorId={colaboradorId} />
        </div>
      </li>
    </ol>
  );
}
